var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCartFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3143_24672)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.49989 24C9.88102 24 11 22.8806 11 21.4998C11 20.1194 9.88102 19 8.49989 19C7.11911 19 6.00009 20.1194 6.00009 21.4998C6.00009 22.8806 7.11946 24 8.49989 24ZM9.46404 13.0007L7.73189 16.0007H21.9997V18.0006H6.94766C5.24267 18.0006 5.03982 16.3164 5.34533 15.7852L7.55761 11.9423L3.40362 1.99956H0V0H4.01358C4.77488 0 5.21727 0.435331 5.40001 0.801164L6.94977 3.90034L7.50011 5.00066H23.2779C23.788 5.00066 23.9968 5.39542 24 5.77643C24.0011 5.92248 23.97 6.06747 23.9171 6.18636L20.5001 13.0007H9.46404ZM19.4999 24C20.8807 24 21.9997 22.8806 21.9997 21.4998C21.9997 20.1194 20.8807 19 19.4999 19C18.1192 19 16.9994 20.1194 16.9994 21.4998C16.9998 22.8806 18.1192 24 19.4999 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5297 1.87575L19.0656 1.02274C18.861 0.968061 18.6522 1.01569 18.4945 1.13422L19 4.00056L22.6486 4.00054L23 2.68961C23.0942 2.33683 22.8829 1.97029 22.5297 1.87575ZM9.28505 1.31482L16.5372 0.0113207C16.9422 -0.0599409 17.3317 0.212758 17.4026 0.617397L17.9992 4.00021L9 4.00019L8.67897 2.1802C8.60771 1.77556 8.88005 1.38609 9.28505 1.31482Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3143_24672"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.9996,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCartFull);
export default __webpack_public_path__ + "static/media/icon_cart_full.00d7f736614f46faefe932b847244a1a.svg";
export { ForwardRef as ReactComponent };